<template>
  <el-row style="margin-left: 2%;padding-top: 10px;">
    <el-button @click="tragourl('Psychological_archives')">基本档案</el-button>
    <el-button @click="tragourl('Crisis_Reporting_file')">危机上报</el-button>
    <el-button @click="tragourl('Crisis_Intervention_File')">危机干预</el-button>
    <el-button @click="tragourl('Evaluation_report_file')">测评报告</el-button>
    <el-button @click="tragourl('Crisis_document')">危机文档</el-button>
  </el-row>
</template>
<script>
export default {
  props: ["users"],
  
  data() {
    return {
      a2: false,
      select: true,
    };
  },
  methods: {
    tragourl(url) {
      this.a2 = true;
      this.$router.push({
        path: url,
        query: { "UserID": this.users },
      })
    }
  },
  mounted() {

  }
};
</script>